module.exports = __webpack_public_path__ + "img/Local-Storage.4dba8212.png";